<template>
  <div id="app">
      <router-view></router-view>
 </div>
</div>
 <!-- 1111 -->
</template>
<script>
//引入vuex 

export default {
   data(){
    return{
        
    }
   },
   created() {
    // 禁止网页缩放
    window.addEventListener(
      "mousewheel",
      function (event) {
        if (event.ctrlKey === true || event.metaKey) {
          event.preventDefault();
        }
      },
      { passive: false }
    );

    //firefox
    window.addEventListener(
      "DOMMouseScroll",
      function (event) {
        if (event.ctrlKey === true || event.metaKey) {
          event.preventDefault();
        }
      },
      { passive: false }
    );
  },

   mounted(){
    
   },
   computed:{
   },
   methods:{
   
   },

}

</script>
<style >
*{
  margin: 0px;
  padding: 0px;
}
#app{
  width: 100%;
  height: 100%;
  background: #e2e2e2cc;
  overflow-x:hidden;
  overflow-y:auto;
}
/* .el-input ,.el-select {
    width: 200px !important;
    height: 40px !important; 
}

.el-button{
  width: 100px !important;
  height: 40px !important; 
} */
         
/* .app-container {
        background-color: #eff3f6;
        height: 100vh;
        overflow: auto;
  }
    ::-webkit-scrollbar {
    width: 9px;
    height: 9px;
}
::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: rgba(0,0,0,0.1);
}
::-webkit-scrollbar-track {
    border-radius: 0;
    background: rgba(0,0,0,0.0);
} */




</style>